// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card[data-v-3be611c5] {\n  width: 60vw;\n  min-width: 800px;\n}", ""]);
// Exports
module.exports = exports;
